import React from 'react';

// Estilos comuns para os ícones
const iconStyle = {
  filter: 'drop-shadow(0 0 2px rgba(64, 128, 255, 0.7))',
  transition: 'all 0.3s ease'
};

const labelIconStyle = {
  marginRight: '8px',
  filter: 'drop-shadow(0 0 3px rgba(64, 128, 255, 0.7))'
};

// Ícones para a tela de registro
export const EyeIcon = ({ visible }) => (
  <svg 
    width="22" 
    height="22" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={iconStyle}
  >
    {visible ? (
      <>
        <path d="M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z" 
          stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" 
          stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 3L21 21" stroke="rgba(255, 100, 100, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </>
    ) : (
      <>
        <path d="M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z" 
          stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" 
          stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </>
    )}
  </svg>
);

export const SecurityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={labelIconStyle}>
    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CompanyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={labelIconStyle}>
    <path d="M3 21H21" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 21V7L13 3V21" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 21V12L13 8" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 9H9.01" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 13H9.01" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 17H9.01" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 17H17.01" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const SegmentIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={labelIconStyle}>
    <path d="M16 3H21V8" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 21H3V16" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 16V21H16" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 8V3H8" stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const WhatsAppIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={labelIconStyle}>
    <path d="M3 21L5 15C3.9 13.6 3.5 11.6 4 9.5C4.5 7.5 5.9 5.9 7.8 5C9.7 4.2 11.9 4.3 13.7 5.3C15.5 6.3 16.7 8 17 10C17.3 12 16.7 14.1 15.4 15.6C14.1 17.1 12.1 18 10 18C8.9 18 7.7 17.7 6.7 17.1L3 21Z" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 10C9.5 11.5 10.5 12.5 12 13" 
      stroke="rgba(100, 182, 255, 0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Estilos para botões e elementos visuais
export const buttonStyles = {
  base: {
    position: 'relative',
    overflow: 'hidden'
  },
  back: {
    width: '48%', 
    background: 'rgba(64, 128, 255, 0.3)'
  },
  next: {
    width: '48%'
  },
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(45deg, rgba(76, 110, 245, 0.5) 0%, rgba(100, 182, 255, 0.8) 100%)',
    opacity: 0.5,
    zIndex: 1
  },
  gradientLight: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'linear-gradient(45deg, rgba(64, 128, 255, 0.1) 0%, rgba(64, 128, 255, 0.3) 100%)',
    opacity: 0.5,
    zIndex: 1
  },
  text: {
    position: 'relative',
    zIndex: 2
  }
};

export const titleStyle = {
  textAlign: 'center', 
  marginBottom: '1.5rem',
  position: 'relative',
  zIndex: 2,
  textShadow: '0 0 10px rgba(64, 128, 255, 0.5)'
};

export const passwordToggleStyle = {
  position: 'absolute',
  right: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0',
  transition: 'all 0.3s ease',
  opacity: '0.8'
};
